export default "__VITE_ASSET__Ch2$zPQD__"